export default __webpack_public_path__ + "static/media/premium-exercise.ea81e56d.jpg";